module.exports = __webpack_public_path__ + "78f52881270040d2b44f496f254aa08b.jpg";